import React, { useState } from 'react'

export default function CopyButton({ text, label = 'Copy', small = false }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    if (!text) return
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      /* ignore errors */
    }
  }

  return (
    <button
      onClick={handleCopy}
      className={`border rounded ${small ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'} hover:bg-gray-50`}
      title={copied ? 'Copied!' : 'Copy to clipboard'}
    >
      {copied ? 'Copied!' : label}
    </button>
  )
}
